
<template>
  <div class="w-full table">
    <el-table
      class="w-full"
      ref="multipleTable"
      v-loading="loading"
      :data="dataSource"
      empty-text="暂无数据"
      :height="h"
      @selection-change='selectionChange'
      @cell-dblclick ="handleClick"
    >
    <el-table-column
      v-if="select"
      type="selection"
      align="center"
      width="60">
    </el-table-column>
      <el-table-column
        v-for="item in columns"
        :key="item.prop"
        v-bind="{ ...item }"
        :show-overflow-tooltip="tooltip"
      >
        <template #default="scope" v-if="item.scopedSlots">
          <slot :name="item.scopedSlots" v-bind="{ ...scope }"></slot>
        </template>
      </el-table-column>
    </el-table>
    <!--  只有一页不显示分页 -->
    <el-pagination
      class="pageination flex items-center justify-end"
      layout="total, prev, pager, next,sizes"
      :hide-on-single-page='!showSize'
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :page-sizes="showSize ? [10, 20, 50, 100] : []"
      :current-page="pagination.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'STable',
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    loadData: {
      type: Function,
      default: () => () => {},
      required: true
    },
    size: {
      type: Number,
      default: 10
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    showSize: {
      type: Boolean,
      default: true
    },
    select: {
      type: Boolean,
      default: false
    },
    selectList:{
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      pagination: {
        pageNum: 1,
        pageSize: this.size,
        total: 0
      },
      dataSource: [],
      h: null
    };
  },
  created () {
    this.refresh(true);
  },
  methods: {
    async refresh (bool = false) {
      if (bool) {
        this.pagination.pageNum = 1;
        this.pagination.total = 0;
        this.dataSource = [];
      }
      const { pageNum, pageSize } = this.pagination;
      const result = await this.bindLoading({ pageNum, pageSize });
      this.clearSelect()
      this.dataSource = result.data.dataList || [];
      this.pagination.total = result.data.totalCount || 0;
    },
    // 换页
    handleCurrentChange (pageNum) {
      this.pagination.pageNum = pageNum;
      this.refresh();
    },
    handleSizeChange (pageSize) {
      this.pagination.pageSize = pageSize;
      this.refresh();
    },
    bindLoading (params) {
      return new Promise((resolve) => {
        this.loading = true;
        this.loadData(params)
          .then((rs) => resolve(rs))
          .finally(() => (this.loading = false));
      });
    },
    selectionChange(val){
      this.$emit('selectionChange',val)
    },
    clearSelect(){
      if (this.select && this.$refs.multipleTable) this.$refs.multipleTable.clearSelection()
    },
  handleClick(row, column, cell, event){
    this.$emit('cellDblclick',row)
  }
  }
};
</script>

<style lang="scss" scoped>
.w-full{
    width: 100%;
}
.pageination {
  margin: 20px 0 10px;
  text-align: right;
}

</style>

<style lang="scss">
.table{
    thead{
       .el-table__cell{
          padding: 5px 0;
        }
        th{
         background-color: #ededed;
        }
    }
    tbody{
       .el-table__cell{
          padding: 10px 0;
        }
        .el-checkbox__label{
          display: none;
        }
    }
    a{
        text-decoration:none;
        color:#409EFF;
        margin-right: 10px;
        font-size: 14px;
    }
    .success{
        color: #67C23A;
    }
    .delete{
        color: #F56C6C;
    }
}

</style>
